// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"ZW-z","sponsoredTooltipWrapper":"_W-z","sponsoredTooltip":"aX-z","newCard":"bX-z"};